var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconImageAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3686_7617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.55859 10.52V12.52L7.84859 13.23L8.84859 14.23L9.55859 14.52H11.5586L12.2686 14.23L13.2686 13.23L13.5586 12.52V10.52L13.2686 9.81003L12.2686 8.81003L11.5586 8.52003H9.55859L8.84859 8.81003L7.84859 9.81003L7.55859 10.52V10.52ZM9.55859 10.93L9.96859 10.52H11.1386L11.5486 10.93V12.1L11.1386 12.51H9.96859L9.55859 12.1V10.93ZM21.5586 4.52003H11.5586V6.52003H20.5586V15.15L17.6486 12.32H16.2686L9.60859 18.52H5.55859V12.52H3.55859V19.52L4.55859 20.52H21.5586L22.5586 19.52V5.52003L21.5586 4.52003ZM12.5286 18.52L16.9286 14.42L20.5586 17.95V18.53H12.5286V18.52ZM3.55859 6.53003H0.558594V4.53003H3.55859V1.53003H5.55859V4.53003H8.55859V6.53003H5.55859V9.53003H3.55859V6.53003Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3686_7617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.558594 0.52002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageAdd);
export default __webpack_public_path__ + "static/1778142529/media/icon-image-add.db5a60530466b898825d39ff5f294665.svg";
export { ForwardRef as ReactComponent };